import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagSuccessRounded = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--success-rounded', className].filter(Boolean).join(' ')} />
);
